import * as React from "react"

import { cn } from "@/lib/utils"

const baseClass = "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"

// Les champs type="number" acceptent la virgule (2,5) : affichée avec virgule, transmise avec un point
const Input = React.forwardRef(({ className, type, value, onChange, onBlur, ...props }, ref) => {
  const [raw, setRaw] = React.useState(null)
  const isNum = type === "number"

  React.useEffect(() => {
    if (raw === null) return
    const n = parseFloat(raw.replace(",", "."))
    const v = value === "" || value === null || value === undefined ? NaN : Number(value)
    if (!(n === v || (isNaN(n) && isNaN(v)))) setRaw(null)
  }, [value]) // eslint-disable-line react-hooks/exhaustive-deps

  if (!isNum) {
    return <input type={type} value={value} onChange={onChange} onBlur={onBlur} className={cn(baseClass, className)} ref={ref} {...props} />
  }

  const controlled = value !== undefined
  const display = raw !== null ? raw : (value === null || value === undefined ? "" : String(value).replace(".", ","))

  const handleChange = (e) => {
    const txt = e.target.value.replace(/[^0-9.,-]/g, "")
    if (controlled) setRaw(txt)
    e.target.value = txt.replace(",", ".")
    if (onChange) onChange(e)
  }
  const handleBlur = (e) => {
    setRaw(null)
    if (onBlur) onBlur(e)
  }

  return (
    <input
      type="text"
      inputMode="decimal"
      {...(controlled ? { value: display } : {})}
      onChange={handleChange}
      onBlur={handleBlur}
      className={cn(baseClass, className)}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
